import Splide from '@splidejs/splide';

function initSliders() {
    console.log("Test this");
    document.querySelectorAll('.splide').forEach(function(slider) {
        new Splide(slider, {
            type: 'slide',
            perPage: 1,
            arrows: false,
            pagination: false,
            gap: '24px',
            padding: { left: '0', right: '15%' },  
        }).mount();
    });
}

const sliders = document.querySelectorAll('.splide');

if (sliders.length) {
    initSliders();
}